{
  "Paramètres": "Paramètres",
  "Patients": "Patients",
  "Clinique": "Clinique",
  "Questionnaire": "Questionnaire",
  "Laboratoires": "Laboratoires",
  "Implants": "Implants",
  "Déconnexion": "Déconnexion",
  "Connexion": "Connexion",
  "Biométrie": "Biométrie",
  "Physiologie": "Physiologie",
  "Habitude": "Habitudes",
  "Implant": "Implant",
  "Rapport": "Rapport",
  "Mercide de remplir le": "Merci de remplir le",
  "formulaire d'habitudes": "formulaire d'habitudes",
  "Intervalle": "Intervalle",
  "AV(LogMAR)": "AV(LogMAR)",
  "Occurence": "Occurence",
  "Infini": "Infini",
  "Sélectionner une valeur": "Sélectionner une valeur",
  "Lunettes": "Lunettes",
  "Annuler": "Annuler",
  "Enregistrer": "Enregistrer",
  "Fermer": "Fermer",
  "Oui": "Oui",
  "Non": "Non",
  "Activité": "Activité",
  "Optionnel": "Optionnel",
  "Pourquoi le patient souhaite garder ce champ de vision ?": "Pourquoi le patient souhaite garder ce champ de vision ?",
  "Distance minimum (m)": "Distance minimum (m)",
  "Distance maximum (m)": "Distance maximum (m)",
  "Préconisé à": "Préconisé à",
  "Informations générales": "Informations générales",
  "Sexe": "Sexe",
  "Valider": "Valider",
  "Informations générales enregistrées": "Informations générales enregistrées",
  "Habitudes enregistrées": "Habitudes enregistrées",
  "Temps d'éveil": "Temps d'éveil",
  "Vision de près": "Vision de près",
  "Vision intermédiaire": "Vision intermédiaire",
  "Vision de loin": "Vision de loin",
  "Activités préférentielles": "Activités préférentielles",
  "Précédent": "Précédent",
  "Suivant": "Suivant",
  "Source": "Source",
  "Courbes de défocus": "Courbes de défocus",
  "Courbe de défocus": "Courbe de défocus",
  "Monocular": "Monoculaire",
  "Binocular": "Binoculaire",
  "obtenue avec": "obtenue avec",
  "patients": "patients",
  "avec la méthodologie": "avec la méthodologie",
  "Comparaison d'implant": "Comparaison d'implant",
  "Implants favoris": "Implants favoris",
  "Laboratoire": "Laboratoire",
  "Choisir": "Choisir",
  "Retirer des favoris": "Retirer des favoris",
  "Ajouter aux favoris": "Ajouter aux favoris",
  "Larmes": "Larmes",
  "Cornée": "Cornée",
  "Pupille": "Pupille",
  "Rétine et/ou nerf optique": "Rétine et/ou nerf optique",
  "Longueur axiale": "Longueur axiale",
  "Correction": "Correction",
  "Matériau": "Matériau",
  "Valeurs": "Valeurs",
  "Nom": "Nom",
  "Nom de famille": "Nom",
  "Notes": "Notes",
  "Type": "Type",
  "Supprimer": "Supprimer",
  "Ajouter": "Ajouter",
  "Mauvais état à partir de ": "Mauvais état à partir de ",
  "Ajout docteur": "Ajout docteur",
  "Email": "Email",
  "Prénom": "Prénom",
  "Numéro RPPS": "Numéro RPPS",
  "Type de compte": "Type de compte",
  "Créer": "Créer",
  "Édition docteur": "Édition docteur",
  "Suppression docteur": "Suppression docteur",
  "Attention cette action est irréversible et empêchera le docteur d'accéder à son compte et à tous les patients associés, ainsi qu'à votre clinique.": "Attention cette action est irréversible et empêchera le docteur d'accéder à son compte et à tous les patients associés, ainsi qu'à votre clinique.",
  "Êtes-vous certaine de vouloir supprimer le compte ?": "Êtes-vous certaine de vouloir supprimer le compte ?",
  "Médecins de la clinique": "Médecins de la clinique",
  "Ajout patient": "Ajout patient",
  "Date de naissance": "Date de naissance",
  "Modification patient": "Modification patient",
  "Suppression patient": "Suppression patient",
  "Attention cette action est irréversible et vous empêchera d'accéder à toutes les informations relative au patient.": "Attention cette action est irréversible et vous empêchera d'accéder à toutes les informations relative au patient.",
  "Êtes-vous certaine de vouloir supprimer le patient ?": "Êtes-vous certaine de vouloir supprimer le patient ?",
  "Patients de la clinique": "Patients de la clinique",
  "Ajouter un patient": "Ajouter un patient",
  "Admininistrateur clinique": "Admininistrateur clinique",
  "Docteur": "Docteur",
  "Non nécessaire": "Non nécessaire",
  "Bon": "Bon",
  "Mauvais": "Mauvais",
  "Moyen": "Moyen",
  "Sévère": "Sévère",
  "Positive": "Positive",
  "Nulle": "Nulle",
  "Négative": "Négative",
  "Homme": "Homme",
  "Femme": "Femme",
  "Taille": "Taille",
  "Antécédent de chirurgie réfractive au laser": "Antécédent de chirurgie réfractive au laser",
  "Bump": "Bump",
  "Le patient souhaite être indépendant aux lunettes ?": "Le patient souhaite être indépendant aux lunettes ?",
  "Le patient accepte les effets photiques ?": "Le patient accepte les effets photiques ?",
  "Heure de coucher": "Heure de coucher",
  "Temps de lecture par jour": "Temps de lecture par jour",
  "Temps de tablette par jour": "Temps de tablette par jour",
  "Temps de smartphone par jour": "Temps de smartphone par jour",
  "Temps d'autres activités de vision de près par jour": "Temps d'autres activités de vision de près par jour",
  "Temps de discussion par jour": "Temps de discussion par jour",
  "Temps de jeux de société par jour": "Temps de jeux de société par jour",
  "Temps d'utilisation de l'ordinateur par jour": "Temps d'utilisation de l'ordinateur par jour",
  "Temps de cuisine par jour": "Temps de cuisine par jour",
  "Temps de conduite par jour": "Temps de conduite par jour",
  "Temps de télévision par jour": "Temps de télévision par jour",
  "Indépendance aux lunettes": "Indépendance aux lunettes",
  "Distance minimum": "Distance minimum",
  "Distance maximum": "Distance maximum",
  "Activité préférentielle": "Activité préférentielle",
  "Hydrophile": "Hydrophile",
  "Hydrophobe": "Hydrophobe",
  "MIOL": "MIOL",
  "EDOF": "EDOF",
  "Monofocal": "Monofocal",
  "Hybrid": "Hybride",
  "CDVA": "CDVA",
  "NDVA": "NDVA",
  "High Order Aberration": "Aberration d'ordre élevé",
  "Aberration sphérique": "Aberration sphérique",
  "Endothelium": "Endothelium",
  "Diamètre pupillaire": "Diamètre pupillaire",
  "Aucune correction": "Aucune correction",
  "Heure de réveil": "Heure de réveil",
  "Temps de sieste": "Temps de sieste",
  "Habitudes visuelles": "Habitudes visuelles",
  "Préconisation": "Préconisation",
  "Choix implant": "Choix implant",
  "Choix": "Choix",
  "P1": "IOL Match est une application destinée aux chirurgiens, et vous aide à mieux cibler les besoins de vos patients avant une chirurgie du cristallin. L’objectif étant de vous accompagner lors du choix d’implant intraoculaire, afin qu’il soit le plus adapté aux habitudes visuelles ainsi qu’aux paramètres oculaires de vos patients. Merci de bien vouloir compléter les informations de biométrie ainsi que le questionnaire d’habitudes visuelles, et laissez-vous guider vers une préconisation d’implant optimisée !",
  "P2": "IOL Match ne remplace pas l’analyse et l’expertise du médecin, et ne peut en aucun cas être tenu responsable du choix final. IOL Match n’est qu’un outil supplémentaire permettant de retranscrire les habitudes et besoins visuels afin de mieux accompagner le médecin et le patient lors de la décision d’implant intraoculaire.",
  "ans": "ans",
  "Le patient a des antécédents de chirurgie laser réfractive avec un bon bump.": "Le patient a des antécédents de chirurgie laser réfractive avec un bon bump.",
  "Le patient a des antécédents de chirurgie laser réfractive avec un mauvais bump.": "Le patient a des antécédents de chirurgie laser réfractive avec un mauvais bump.",
  "Le patient n'a pas d'antécédent de chirurgie laser réfractive.": "Le patient n'a pas d'antécédent de chirurgie laser réfractive.",
  "Le patient souhaite être indépendant des lunettes.": "Le patient souhaite être indépendant des lunettes.",
  "Le patient accepte de porter des lunettes": "Le patient accepte de porter des lunettes",
  "Le patient accepte les effets photiques.": "Le patient accepte les effets photiques.",
  "Le patient n'accepte pas les effets photiques.": "Le patient n'accepte pas les effets photiques.",
  "Âge": "Âge",
  "Exporter": "Exporter",
  "Besoin de lunettes": "Besoin de lunettes",
  "Choix final": "Choix final",
  "Type d'implant": "Type d'implant",
  "Nom de l'implant": "Nom de l'implant",
  "P3": "IOL Match ne remplace pas l’analyse et l’expertise du médecin, et ne peut en aucun cas être tenu responsable du choix final. IOL Match n’est qu’un outil supplémentaire permettant de retranscrire les habitudes et besoins visuels afin de mieux accompagner le médecin et le patient lors de la décision d’implant intraoculaire.",
  "Télécharger": "Télécharger",
  "Courbes": "Courbes",
  "Rétine/NO": "Rétine/NO",
  "Génération du pdf...": "Génération du pdf...",
  "Choisir un implant": "Choisir un implant",
  "Modifier": "Modifier",
  "Sélectionner un type": "Sélectionner un type",
  "Password not long enough": "Mot de passe pas assez long",
  "Sélectionner": "Sélectionner",
  "Mot de passe": "Mot de passe",
  "Inscription": "Inscription",
  "Mot de passe oublié": "Mot de passe oublié",
  "Pas encore inscrit": "Pas encore inscrit ?",
  "Récupérer mot de passe": "Récupérer mot de passe",
  "S'affilier à une clinique": "S'affilier à une clinique",
  "Créer une clinique": "Créer une clinique",
  "Continuer": "Continuer",
  "Retour": "Retour",
  "Nom de la clinique": "Nom de la clinique",
  "Confirmation du mot de passe": "Confirmation du mot de passe",
  "En cas d’aléa réfractif il sera peut nécessaire de porter une correction optique pour optimiser votre vision": "En cas d’aléa réfractif il sera peut nécessaire de porter une correction optique pour optimiser votre vision.",
  "Recherche": "Recherche",
  "Recherche par nom": "Recherche par nom",
  "Bienvenue sur IOL Match": "Bienvenue sur IOL Match !",
  "Taille en cm": "Taille en cm",
  "État de l'oeil": "État de l'oeil",
  "Ajouter un docteur": "Ajouter un docteur",
  "Édition d'un implant": "Édition d'un implant",
  "Création d'un implant": "Création d'un implant",
  "Monoculaire ou Binoculaire": "Monoculaire ou Binoculaire",
  "Taille échantillon de test (N)": "Taille échantillon de test (N)",
  "Méthodologie": "Méthodologie",
  "Note": "Note",
  "Aperçu": "Aperçu",
  "ATTENTION": "ATTENTION",
  "Si vous supprimer cet implant il n'apparaitra plus sur le profil des patients pour lesquels l'implant a été choisis.": "Si vous supprimer cet implant il n'apparaitra plus sur le profil des patients pour lesquels l'implant a été choisis.",
  "Cette action est irréversible, voulez-vous supprimer l'implant ?": "Cette action est irréversible, voulez-vous supprimer l'implant ?",
  "Ajouter un implant": "Ajouter un implant",
  "Si vous supprimer ce laboratoire vous supprimerez également tous les implants associés. Ceux-ci n'apparaitront plus sur le profil des patients pour lesquels les implants du laboratoire ont été choisis.": "Si vous supprimer ce laboratoire vous supprimerez également tous les implants associés. Ceux-ci n'apparaitront plus sur le profil des patients pour lesquels les implants du laboratoire ont été choisis.",
  "Cette action est irréversible, voulez-vous supprimer le laboratoire ?": "Cette action est irréversible, voulez-vous supprimer le laboratoire ?",
  "Suppression d'un laboratoire": "Suppression d'un laboratoire",
  "Suppression d'un implant": "Suppression d'un implant",
  "Création d'un laboratoire": "Création d'un laboratoire",
  "Édition d'un laboratoire": "Édition d'un laboratoire",
  "Ajouter un laboratoire": "Ajouter un laboratoire",
  "Réinitialiser": "Réinitialiser",
  "Biométrie enregistrée": "Biométrie enregistrée",
  "en m": "en m",
  "Choisir cet implant": "Choisir cet implant",
  "entre 2mm et 2.5mm": "entre 2mm et 2.5mm",
  "patient": {
    "greeting": "Bonjour",
    "welcomeTitle": "Accès au formulaire",
    "accessGranted": "Accès autorisé",
    "email": "Email",
    "telephone": "Téléphone",
    "nextSteps": "Prochaines étapes",
    "stepBiometrie": "Données biométriques",
    "stepBiometrieDesc": "Informations sur votre vision",
    "stepHabitudes": "Habitudes visuelles",
    "stepHabitudesDesc": "Vos activités quotidiennes",
    "stepValidation": "Validation",
    "stepValidationDesc": "Confirmation de vos données",
    "startForm": "Commencer le questionnaire",
    "step": "Étape",
    "of": "sur",
    "completed": "complété",
    "loading": "Chargement...",
    "completeForm": "Compléter le formulaire",
    "completeFormDesc": "Remplissez vos informations biométriques et habitudes visuelles",
    "schedule": "Horaires",
    "saving": "Sauvegarde en cours...",
    "savedAt": "Sauvegardé",
    "justNow": "À l'instant",
    "minuteAgo": "Il y a 1 minute",
    "minutesAgo": "Il y a {{count}} minutes",
    "hourAgo": "Il y a 1 heure",
    "hoursAgo": "Il y a {{count}} heures",
    "dataSection": "Données",
    "lastName": "Nom",
    "firstName": "Prénom",
    "gender": "Sexe",
    "male": "Masculin",
    "female": "Féminin",
    "height": "Taille en cm",
    "birthdate": "Date de naissance",
    "acceptPhoticEffects": "Acceptez-vous les effets photiques ?",
    "wantGlassesIndependence": "Souhaitez-vous être indépendant aux lunettes ?",
    "yes": "Oui",
    "no": "Non",
    "validate": "Valider",
    "previous": "Précédent",
    "next": "Suivant",
    "selectGenderError": "Veuillez sélectionner votre sexe",
    "enterBirthdateError": "Veuillez renseigner votre date de naissance",
    "enterHeightError": "Veuillez entrer une taille valide (entre 100 et 250 cm)",
    "saveError": "Erreur lors de la sauvegarde",
    "wakeupTime": "Temps d'éveil",
    "wakeupHour": "Heure de réveil",
    "bedtimeHour": "Heure de coucher",
    "napTime": "Temps de sieste",
    "nearVision": "Vision de près",
    "readingTime": "Temps de lecture par jour",
    "tabletTime": "Temps de tablette par jour",
    "smartphoneTime": "Temps de smartphone par jour",
    "otherNearVisionTime": "Temps d'autres activités de vision de près par jour",
    "intermediateVision": "Vision intermédiaire",
    "discussionTime": "Temps de discussion par jour",
    "boardGamesTime": "Temps de jeux de société par jour",
    "computerTime": "Temps d'utilisation de l'ordinateur par jour",
    "cookingTime": "Temps de cuisine par jour",
    "distanceVision": "Vision de loin",
    "drivingTime": "Temps de conduite par jour",
    "tvTime": "Temps de télévision par jour",
    "preferredActivities": "Activités préférentielles",
    "activity": "Activité",
    "whyKeepDepthOfField": "Pourquoi souhaitez-vous garder cette profondeur de champ ?",
    "minDistance": "Distance minimum (m)",
    "maxDistance": "Distance maximum (m)",
    "addActivity": "Ajouter une activité",
    "removeLastActivity": "Supprimer la dernière activité",
    "confirmationTitle": "Confirmation de vos données",
    "confirmationDesc": "Veuillez vérifier les informations saisies avant de soumettre le formulaire",
    "submit": "Soumettre",
    "submitting": "Envoi en cours...",
    "thankYou": "Merci !",
    "formSubmitted": "Votre formulaire a été soumis avec succès",
    "dataRecap": "Récapitulatif de vos données",
    "tokenMissing": "Token manquant dans l'URL. Veuillez utiliser le lien complet fourni par votre chirurgien.",
    "technicalError": "Erreur technique. Veuillez réessayer.",
    "connectionError": "Erreur de connexion. Veuillez vérifier votre connexion internet et réessayer.",
    "linkInvalid": "Ce lien n'est pas valide. Veuillez vérifier que vous utilisez le lien complet envoyé par votre chirurgien.",
    "linkExpired": "Ce lien a expiré. Veuillez contacter votre chirurgien pour obtenir un nouveau lien.",
    "linkUsed": "Ce lien a déjà été utilisé. Si vous devez modifier vos informations, veuillez contacter votre chirurgien.",
    "validating": "Validation en cours...",
    "verifyingLink": "Vérification de votre lien d'accès",
    "retry": "Réessayer",
    "validationFailed": "Validation échouée",
    "correctErrors": "Veuillez corriger les erreurs avant de continuer",
    "tokenNotFound": "Token non trouvé",
    "error": "Erreur",
    "biometricData": "Données biométriques",
    "visualHabits": "Habitudes visuelles",
    "importantInfo": "Informations importantes",
    "modify": "Modifier",
    "finalize": "Finaliser et envoyer",
    "formSentSuccess": "Formulaire envoyé avec succès",
    "thankYouMessage": "Merci d'avoir complété le formulaire. Votre chirurgien a bien reçu vos informations.",
    "close": "Fermer",
    "recap": "Récapitulatif",
    "reviewBeforeSubmit": "Veuillez vérifier vos informations avant de soumettre le formulaire",
    "sex": "Sexe",
    "size": "Taille",
    "acceptsPhoticEffects": "Accepte les effets photiques",
    "wantsGlassesIndependence": "Souhaite être indépendant aux lunettes",
    "wakeTime": "Temps d'éveil",
    "napDuration": "Durée de sieste",
    "readingDuration": "Durée de lecture",
    "tabletDuration": "Durée de tablette",
    "smartphoneDuration": "Durée de smartphone",
    "otherNearActivities": "Autres activités de près",
    "discussionDuration": "Durée de discussion",
    "boardGamesDuration": "Durée de jeux de société",
    "computerDuration": "Durée d'ordinateur",
    "cookingDuration": "Durée de cuisine",
    "drivingDuration": "Durée de conduite",
    "tvDuration": "Durée de télévision",
    "activities": "Activités",
    "distance": "Distance",
    "name": "Nom",
    "description": "Description",
    "confidentiality": "Confidentialité",
    "confidentialityDesc": "Vos données sont sécurisées et ne seront utilisées que dans le cadre de votre prise en charge médicale.",
    "modifications": "Modifications",
    "modificationsDesc": "Après envoi, contactez votre chirurgien pour toute modification.",
    "followUp": "Suivi",
    "followUpDesc": "Votre chirurgien vous contactera pour la suite de votre prise en charge.",
    "sending": "Envoi...",
    "dataAnalysis": "Analyse de vos données",
    "dataAnalysisDesc": "Votre chirurgien va analyser vos informations",
    "implantChoice": "Choix de l'implant",
    "implantChoiceDesc": "Sélection de l'implant le plus adapté",
    "contactYou": "Prise de contact",
    "contactYouDesc": "Vous serez contacté pour la planification",
    "thankYouFull": "Merci {{name}} ! Vos données ont été transmises à votre chirurgien. Vous serez contacté(e) prochainement pour la suite de votre prise en charge.",
    "canCloseWindow": "Le questionnaire est terminé et l'équipe médicale a bien reçu vos réponses. Vous pouvez fermer cette page.",
    "requestNewLink": "Demander un nouveau lien",
    "requestNewLinkSent": "Demande envoyée à votre chirurgien",
    "requestNewLinkError": "Erreur lors de l'envoi de la demande. Veuillez réessayer."
  },
  "sendLink": {
    "title": "Envoyer le questionnaire patient",
    "patientLabel": "Patient",
    "loadingPatient": "Chargement des données patient...",
    "patientNotFound": "Patient non trouvé",
    "back": "Retour",
    "configuration": "Configuration",
    "patientEmail": "E-mail du patient",
    "linkValidity": "Durée de validité",
    "validity24h": "24h",
    "validity48h": "48h",
    "validity72h": "72h",
    "customMessage": "Message d'accompagnement",
    "customMessageHelp": "Le texte [LIEN_QUESTIONNAIRE] sera automatiquement remplacé par le lien généré",
    "customMessagePlaceholder": "Message à envoyer avec le lien du questionnaire",
    "generateLink": "Générer le lien patient",
    "linkGeneratedTitle": "Lien généré avec succès",
    "linkGeneratedDesc": "Le lien suivant a été généré :",
    "validityLabel": "Validité : {{hours}} heures",
    "copy": "Copier",
    "share": "Partager",
    "send": "Envoyer",
    "emailRequired": "Email valide requis",
    "linkGeneratedSuccess": "Lien généré avec succès",
    "linkGenerationError": "Erreur lors de la génération du lien",
    "emailSentSuccess": "Email envoyé avec succès",
    "emailSendError": "Erreur lors de l'envoi de l'email",
    "linkCopied": "Lien copié dans le presse-papier",
    "defaultMessage": "Votre chirurgien vous invite à remplir un questionnaire préopératoire pour préparer votre intervention de la cataracte.\n\nCe questionnaire permettra de personnaliser le choix de votre implant intraoculaire en fonction de vos besoins visuels et de votre mode de vie.\n\nCliquez sur le lien ci-dessous pour accéder au questionnaire :\n[LIEN_QUESTIONNAIRE]\n\nMerci de prendre quelques minutes pour compléter ce formulaire."
  }
}
